var ActivateAccount;
(function (ActivateAccount) {
    var Controller = (function () {
        function Controller() {
            this.errorValidation = new ErrrorValidation.Controller();
            var parentEmailForgot = $('.formContent');
            this.emailInputWrapper = parentEmailForgot.find($('.inputWrapper'));
            this.emailLabelElement = parentEmailForgot.find($('.labelForInput'));
            var _this = this;
            for (var i = 0; i < _this.emailLabelElement.length; i++) {
                _this.errorValidation.StoreOldLabel($(_this.emailLabelElement[i]).attr('id'), $(_this.emailLabelElement[i]).text());
            }
            $('#submitActivateAccount').click(function () {
                var password = $('#activateAccountForm').find("[name='password']");
                var passwordVerified = $('#activateAccountForm').find("[name='passwordVerified']");
                if (!inputValidator.IsNotEmpty(password.val()) || !inputValidator.IsNotEmpty(passwordVerified.val())) {
                    var passwordMustNotBeEmpty = $("[name='PasswordMustNotBeEmpty']");
                    _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, passwordMustNotBeEmpty.val());
                    return false;
                }
                if (!inputValidator.DoesMatch(password.val(), passwordVerified.val())) {
                    var passwordDoesNotMatch = $("[name='PasswordDoesNotMatch']");
                    _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, passwordDoesNotMatch.val());
                    return false;
                }
                helperController.AjaxHelper('DoActivateAccount', 'json', $('#activateAccountForm').serialize(), 'POST',
                    function success(data) {
                        if (data.isValid && data.isDone) {
                            _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, true);
                            _this.errorValidation.SuccessShowHide('inactive', 'active');
                            $('.successWrapper').addClass('active');
                        } else {
                            window.location.href = "/ActivateAccount";
                        }
                    },
                    function failed(data) {
                        _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, data.message);
                        _this.errorValidation.FailedShowHide('inactive', 'active');
                        $('.successWrapper').addClass('active');
                    });
                return true;
            });

            $('#submitSendNewActivationLink').click(function() {
                var email = $('#activateAccountForm').find("[name='email']");
                var notAValidEmail = $("[name='notAValidEmail']").val();
                if (!inputValidator.IsNotEmpty(email.val())) {
                    _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, notAValidEmail);
                    return false;
                }
                helperController.AjaxHelper('NewActivationLink', 'json', "email=" + $("[name='email']").val(), 'POST',
                    function success(data) {
                        if (data.isDone) {
                            _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, true);
                            _this.errorValidation.SuccessShowHide('inactive', 'active');
                            $('.successWrapper').addClass('active');
                        } else {
                            _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, data.message);
                        }
                    },
                    function failed(data) {
                        _this.errorValidation.AddError(_this.emailInputWrapper, _this.emailLabelElement, data.message);
                    });
                return true;
            });
        }
        return Controller;
    })();
    ActivateAccount.Controller = Controller;
})(ActivateAccount || (ActivateAccount = {}));
$(function () {
    new ActivateAccount.Controller();
})